<template>
  <app-interaction-ads-gpt v-if="dataInteraction.tipo === 'GOOGLE_PUBLISHER_TAG'" :data-mode="dataMode" :data-interaction="dataInteraction"></app-interaction-ads-gpt>
  <app-interaction-ads-vast v-else-if="dataInteraction.tipo === 'VAST'" :data-mode="dataMode" :data-interaction="dataInteraction"></app-interaction-ads-vast>
</template>

<script>
import AppInteractionAdsGpt from "./gpt/InteractionAdsGpt.vue";
import AppInteractionAdsVast from "./vast/InteractionAdsVast.vue";


export default {
  components: {
    AppInteractionAdsGpt,
    AppInteractionAdsVast
  }, 

  props: {
    dataInteraction: {
      type: Object,
      required: true,
    },
    dataMode: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
